/**
 * @author wcx
 * 功能：收付单
 */

import { Service } from '@/tools'
export class PaymentOughtService<T extends TSettle.ApiPaymentOught> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TSettle.ApiPaymentOught}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  /**
   *
   * @param data
   * @returns
   * /api/settle/payment/v1/getSettlePaymentReceiptOughtOrders
   * 应收款-应付款列表查询
   */
  getSettlePaymentReceiptOughtOrders = <K extends T['ApiGetSettlePaymentReceiptOughtOrders']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiGetSettlePaymentReceiptOughtOrders', data)

  /**
   *
   * @param data
   * @returns
   * /api/settle/payment/v1/getSettlePaymentReceiptOughtOrderDetail
   * 查询应付-应收详情
   */
  getSettlePaymentReceiptOughtOrderDetail = <K extends T['ApiGetSettlePaymentReceiptOughtOrderDetail']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiGetSettlePaymentReceiptOughtOrderDetail', data)

  /**
   *
   * @param data
   * @returns
   * /api/settle/paymentOught/v1/affirmOrder
   * 确认收款-付款
   */
  affirmOrder = <K extends T['ApiAffirmOrder']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAffirmOrder', data)
}
